module.exports = __webpack_public_path__ + "img/Corning_GLASS_BoxLockup_Logo.706d8b17.svg";